export default "__VITE_ASSET__y2G$SUDo__"